import groupBy from 'lodash/groupBy';

import { AddItem, Item } from '@/domain/models/Order';

interface Dictionary<T> {
  [index: string]: T;
}

export class ItemDomainService {
  static createDictionaryByName(items: Item[]): Dictionary<Item[]> {
    return groupBy(items, (item) => {
      return item.item_name;
    });
  }

  static toFlattenItemList(items: Item[]): (Item | AddItem)[] {
    const addItems: AddItem[] = items.reduce((result: AddItem[], item) => {
      const newAddItems = item.add_items.map((ai) => {
        return {
          ...ai,
          item_name: `[トッピング] ${ai.item_name}`,
          quantity: item.quantity * ai.quantity,
          total_price: item.quantity * ai.total_price,
          delivery_service_name: item.delivery_service_name,
        };
      });
      return [...result, ...newAddItems];
    }, []);

    return [...items, ...addItems];
  }

  static toAddItemList(items: Item[]): AddItem[] {
    return items.reduce(
      (result: AddItem[], item) => [...result, ...item.add_items],
      []
    );
  }
}
